$(document).ready(function () {
  $('a[data-hover-image]').hover(
    function () {
      const imageUrl = $(this).data('hover-image');
      const imageWidth = $(this).data('hover-image-width');
      const imageHeight = $(this).data('hover-image-heigth');

      const aspectRatio = imageWidth / imageHeight;


      $('.img-container-cursor').css({
        'aspect-ratio': `${aspectRatio}`, 
      });

      const existingImage = $(`.img-container-cursor img[src="${imageUrl}"]`);

      if (existingImage.length > 0) {
        // If the image already exists, remove the 'd-none' class
        existingImage.removeClass('d-none');
      } else {
        // If the image doesn't exist, create and append it
        const imgElement = $('<img>')
          .attr('src', imageUrl)
          .addClass('hovered-image');
        $('.img-container-cursor').append(imgElement);
      }
    },
    function () {
      const imageUrl = $(this).data('hover-image');
      const existingImage = $(`.img-container-cursor img[src="${imageUrl}"]`);

      $('.img-container-cursor').css({
        'aspect-ratio': ``, 
      });

      if (existingImage.length > 0) {
        // Add the 'd-none' class to hide the image
        existingImage.addClass('d-none');
        
      }
    }
  );
});
  

